import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }

import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import SaveBar from '@/components/SaveBar'
import SecondaryNav from '@/components/SecondaryNav'
import SecondaryTop from '@/components/SecondaryTop'
import { useSettingsAccess } from '@/composables/useSettingsAccess'
import { useSettingsForm } from '@/composables/useSettingsForm'
import { buildSettingsTabs, firstSettingsPath, settingsTabForPath } from '@/config/settingsTabs'


export default {
  __name: 'SettingsShell',
  props: {
  parent: { type: Object, default: null }
},
  setup(__props) {



const route = useRoute()
const router = useRouter()

const { hasFullAccess, capabilities, canManageUsers, isCatering } = useSettingsAccess()
const { hasUnsavedChanges, handleSubmit, handleDiscard, load } = useSettingsForm()

const areas = computed(() =>
  buildSettingsTabs({
    hasFullAccess: hasFullAccess.value,
    capabilities: capabilities.value,
    canManageUsers: canManageUsers.value,
    isCatering: isCatering.value
  })
)

const activeArea = computed(() => settingsTabForPath(areas.value, route.path))

const headerTabs = computed(() =>
  areas.value.map(area => ({
    id: area.id,
    name: area.name,
    active: area.id === activeArea.value,
    action: () => router.push(area.to)
  }))
)

// Hiding a tab is not the same as closing the page behind it: the old settings screen
// hid a section, where these are routes someone can type. An area this account cannot
// see is an area it cannot open.
onMounted(() => {
  if (!activeArea.value) {
    router.replace(firstSettingsPath(areas.value))
    return
  }
  load()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(SecondaryNav), null, {
    top: _withCtx(() => [
      _createVNode(_unref(SecondaryTop), {
        text: "Settings",
        parent: __props.parent,
        "save-status": true,
        sections: headerTabs.value
      }, null, 8, ["parent", "sections"]),
      _renderSlot(_ctx.$slots, "savebar", {}, () => [
        (_unref(hasFullAccess) || _unref(hasUnsavedChanges))
          ? (_openBlock(), _createBlock(_unref(SaveBar), {
              key: 0,
              "has-unsaved-changes": _unref(hasUnsavedChanges),
              onOnDiscard: _unref(handleDiscard),
              onOnSave: _unref(handleSubmit)
            }, null, 8, ["has-unsaved-changes", "onOnDiscard", "onOnSave"]))
          : _createCommentVNode("", true)
      ])
    ]),
    main: _withCtx(() => [
      _renderSlot(_ctx.$slots, "overlay"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }))
}
}

}